import BotaoAdicionarVinculos from './BotaoAdicionarVinculos';

export default BotaoAdicionarVinculos;
